import React, {useEffect, useState} from 'react';
import {Table} from "antd";
import {getGridTableHeight, amountFormatter} from '../Common/util';

/** -------------------------------------------------------------------------- **/
function ItemNew({itemList, sumData, assetSum}) {

    const itemColumnData =  [
        {
            title: '분류',
            align: 'center',
            colSpan: 2,
            rowSpan: 2,
            children: [
                {
                    title: ' ',
                    dataIndex: 'measure_type',
                    key: 'measure_type',
                    colSpan: 0,
                    width: '120px',
                    align: 'center',
                    fixed: true,
                    // render: (value, row, index) => {
                    //     const obj = {
                    //         children : value,
                    //         props : {},
                    //     }
                    //     if(index >- 1 && value == itemList[index - 1]?.measure_type) {
                    //         obj.props.rowSpan = 0;
                    //     } else {
                    //         for (
                    //             let i = 0;
                    //             index + i != itemList.length &&
                    //             value == itemList[index + i]?.measure_type;
                    //             i += 1
                    //         ) {
                    //             obj.props.rowSpan = i + 1;
                    //         }
                    //     }
                    //     return obj;
                    // },
                    render: (value, row, index) => {
                        return value;
                    },
                    onCell: (record, index) => {
                        const value = record.measure_type; // measure_type 필드값 사용
                        
                        if(index >= 1 && value == itemList[index - 1]?.measure_type) {
                            return {
                                rowSpan: 0
                            };
                        } else {
                            let rowSpan = 1;
                            for (
                                let i = 1;
                                index + i < itemList.length &&
                                value == itemList[index + i]?.measure_type;
                                i += 1
                            ) {
                                rowSpan = i + 1;
                            }
                            return {
                                rowSpan: rowSpan
                            };
                        }
                    }                    
                },
                {
                    title: ' ',
                    dataIndex: 'measure_cd',
                    key: 'measure_cd',
                    colSpan: 0,
                    width: '70px',
                    align: 'center',
                    fixed: true,
                },
            ]
        },
        {
            title: '진단 항목',
            dataIndex: 'measure_nm',
            key: 'measure_nm',
            width: '200px',
            align: 'left',
            fixed: true,
            ellipsis : true,

        },
        {
            title: '중요도',
            dataIndex: 'important_grd',
            key: 'important_grd',
            width: '70px',
            align: 'center',
            ellipsis : true,
            fixed: true,
        },
        {
            title: '등급 통계',
            align: 'center',
            children: [
                {
                    title: '전체',
                    dataIndex: 'stat_measure_total',
                    key: 'stat_measure_total',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '양호',
                    dataIndex: 'stat_measure_Y',
                    key: 'stat_measure_Y',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '취약',
                    dataIndex: 'stat_measure_N',
                    key: 'stat_measure_N',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '부분이행',
                    dataIndex: 'stat_measure_P',
                    key: 'stat_measure_P',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '해당없음',
                    dataIndex: 'stat_measure_NA',
                    key: 'stat_measure_NA',
                    width: '70px',
                    align: 'center',
                },
            ]
        },
        {
            title: '중요도 점수',
            align: 'center',
            children: [
                {
                    title: '전체',
                    dataIndex: 'stat_total_score',
                    key: 'stat_total_score',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '평가',
                    dataIndex: 'stat_eval_score',
                    key: 'stat_eval_score',
                    width: '70px',
                    align: 'center',
                },
            ]
        },
    ];

    
    const [tableLoading, setTableLoading] = useState(true);
    const [data, setData] = useState([]);
    let assetColumns = [];
    let keys;
    let assetKeys = [];
   
    // itemList.sort((a, b) => a.measure_cd.localeCompare(b.measure_cd));
    // 자산 진단결과 값을 필드에 추가 작업
    // __LX001,..등으로 자산을 추출하여 컬럼을 추가함 
    if(itemList.length > 0) {
        keys = Object.keys(itemList[0]);
        keys.map((key) => {
            if(key.substring(0,2) == '__') {
                assetKeys.push(key);
                assetColumns.push(
                    {
                        title: key.substring(2),
                        dataIndex: key,
                        key: key,
                        width: '50px',
                        align: 'center',
                    }
                );
            }
          })
    }

    const columns = [...itemColumnData];
    assetColumns.map((col) => {
      columns.push(col);
    })

    // useEffect(() => {
    //     // 데이터 로딩 로직
    //     fetchData().then(response => {
    //         setData(itemList);
    //         setLoading(false);
    //     });
    // }, []);
    
    return (
        <>
            <div id="divTabs2" className="section" style={{height:getGridTableHeight(220), overflow:'auto'}}>
                <div className="sub_title">
                        {'■ 취약점진단 항목별 통계'}
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table columns={columns}
                        dataSource={itemList}
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        // loading={tableLoading}
                        // scroll={{x: '100%'}}
                        scroll={{x:800,y:600}}
                        style={{height:getGridTableHeight(350)}}
                        rowKey='measure_cd'
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={4} fixed={true} className={'sum_col'}>{'합계'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4} className={'sum_col'}>{amountFormatter(sumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5} className={'sum_col'}>{amountFormatter(sumData.Y)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.N)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={7}>{amountFormatter(sumData.P)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{amountFormatter(sumData.NA)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={9}>{amountFormatter(sumData.total_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={10}>{amountFormatter(sumData.eval_score)}</Table.Summary.Cell>
                                  {assetSum.map((asset, i) => {
                                        return (
                                            <Table.Summary.Cell  key={`asset-${i}`} index={11+i}>{amountFormatter(asset.sum)} (Y)</Table.Summary.Cell>
                                        )
                                    })
                                  }
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
            </div>
        </>
    );
}
export default ItemNew;